/**
 * isOwnAppUrl — is this URL served by our own web app?
 *
 * Exists for the short-link WebView's native hand-off. The deep-link matchers
 * in RootNavigator look for path FRAGMENTS (`extractEmergencyParams` only needs
 * `/emergency/` to appear anywhere in the URL), and a short link's destination
 * is very often a presigned S3 URL whose object key we do not control. Without
 * an origin gate in front of them, a document filed under an `emergency/`
 * prefix would be pulled out of the WebView and into the EmergencyCard screen.
 *
 * Compared against the configured base — EXPO_PUBLIC_WEB_APP_URL, or the
 * per-stage default in config.ts — rather than a hardcoded host, so dev and
 * prod both work and a domain change lands in one place.
 */

import config from '../config';

/** The app's own custom scheme, as registered in app.json. */
const APP_SCHEME = 'com.eleplan.app://';

export function isOwnAppUrl(url: string | null | undefined): boolean {
  const lower = String(url || '').toLowerCase();
  if (!lower) return false;
  if (lower.startsWith(APP_SCHEME)) return true;

  // Trailing slashes are stripped from BOTH sides before comparing, then a
  // single one is required — otherwise `https://app.eleplan.com.evil.test/x`
  // would pass a bare `startsWith(base)`.
  const base = String(config.webApp?.baseUrl || '').toLowerCase().replace(/\/+$/, '');
  if (!base) return false;
  return lower === base || lower.startsWith(`${base}/`) || lower.startsWith(`${base}?`) || lower.startsWith(`${base}#`);
}
